export default __webpack_public_path__ + "static/media/nsc-img1.044bbd4d.png";